import Box from '@mui/joy/Box'
import type { Moment } from 'moment'
// @ts-ignore: No TS declaration present for the timezone data bundle.
import moment from 'moment-timezone/builds/moment-timezone-with-data-10-year-range.js'
import { useTranslation } from 'react-i18next'

export default function GarageDetailEndTime({
    requestedDate,
    requestedTime,
    effectiveEndsAt,
    desktop = false,
}: {
    requestedDate: Moment | null,
    requestedTime: string | null,
    effectiveEndsAt: string | null,
    desktop?: boolean,
}) {
    const { t, i18n } = useTranslation()
    const dateFormat = desktop ? 'DD.MM.YYYY' : 'dd DD.MM.YYYY'
    const requestedDateLabel = requestedDate !== null
        ? requestedDate.clone().locale(i18n.language).format(dateFormat)
        : '- -. - -. - - - -'
    const requestedTimeLabel = requestedTime ?? '--:--'
    const parsedEnd = effectiveEndsAt ? moment.parseZone(effectiveEndsAt, moment.ISO_8601, true).tz('Europe/Prague') : null
    const effectiveEnd = parsedEnd?.isValid() ? parsedEnd.locale(i18n.language) : null
    const dateChanged = effectiveEnd && effectiveEnd.format('YYYY-MM-DD') !== requestedDate?.format('YYYY-MM-DD')
    const requestedDateTime = <><b>{requestedDateLabel}</b>, {requestedTimeLabel}</>

    if (desktop) {
        return (
            <>
                <Box pl={2} sx={{ gridColumn: 3, gridRow: 1 }}>
                    <Box sx={{ fontSize: '0.750rem', textTransform: 'uppercase', fontWeight: 600, color: 'primary.500' }}>
                        {t('search.reservationEnd')}
                    </Box>
                    <Box minWidth="8.25rem" sx={{ whiteSpace: 'nowrap' }}>
                        {effectiveEnd && dateChanged ? <s>{requestedDateTime}</s> :
                            <><b>{requestedDateLabel}</b>, {effectiveEnd ? <s>{requestedTimeLabel}</s> : requestedTimeLabel}</>
                        }
                    </Box>
                </Box>
                {effectiveEnd &&
                    <Box pl={2} sx={{ gridColumn: 3, gridRow: 2, color: 'customGreen.dark', whiteSpace: 'nowrap' }}>
                        <Box minWidth="8.25rem" sx={{ textAlign: 'left' }}>
                            {!dateChanged &&
                                <Box component="span" aria-hidden="true" sx={{ visibility: 'hidden' }}>
                                    <b>{requestedDateLabel}</b>,{' '}
                                </Box>
                            }
                            <time dateTime={effectiveEnd.format()}>
                                {dateChanged && <><b>{effectiveEnd.format(dateFormat)}</b>, </>}
                                {effectiveEnd.format('HH:mm')}
                            </time>
                        </Box>
                    </Box>
                }
            </>
        )
    }

    return (
        <Box sx={{ position: 'relative', whiteSpace: 'nowrap', color: effectiveEnd ? 'customGreen.dark' : 'inherit' }}>
            {effectiveEnd &&
                <Box component="s" sx={{
                    position: 'absolute', bottom: '100%', left: 0,
                    fontSize: '0.625rem', lineHeight: 1.25, color: 'neutral.600',
                }}>
                    {requestedDateLabel}, {requestedTimeLabel}
                </Box>
            }
            {effectiveEnd ?
                <time dateTime={effectiveEnd.format()}><b>{effectiveEnd.format(dateFormat)}</b>, {effectiveEnd.format('HH:mm')}</time>
                : requestedDateTime
            }
        </Box>
    )
}
